import React, { useContext, useEffect, useState } from "react";
import axiosInstance from "../../utils/Requests/axios";
import { useNavigate } from "react-router-dom";
import LanguageContext from "../../utils/Contexts/LanguageContext";

function ResendEmail({ formData, setFormData }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const { t } = useContext(LanguageContext);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const validate = () => {
    const newErrors = {};
    if (!/\S+@\S+\.\S+/.test(username)) {
      newErrors.email = "Please enter a valid email address.";
    }
    return newErrors;
  };

  useEffect(() => {
    const validationErrors = validate();
    setErrors(validationErrors);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username]);

  const handleResendEmail = (e) => {
    e.preventDefault();
    setSubmitted(true);

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    const payload = {
      username 
    };
    axiosInstance
      .post("/auth/verify", payload)
      .then(() => {
        // Handle success logic (e.g., redirect, show a message)
        const dupObj = { ...formData };
        dupObj.username = username;
        setFormData(dupObj);
        navigate("/verify-email");
      })
      .catch((error) => {
        console.error("Error occured in sending verify email request", error);
        // Handle error logic (e.g., show error message)
      });
  };

  return (
    <div
      className="w-100 content-space-t-4 content-space-t-lg-2 content-space-b-1"
      style={{ maxWidth: "25rem" }}
      onSubmit={handleResendEmail}
    >
      <form className="js-validate needs-validation" novalidate="">
        <div className="text-center">
          <div className="mb-5">
            <h1 className="display-5">{t("Resend Verification Email")}</h1>
            <p>
              {t(
                "Enter the email address you used when you joined and we'll send you instructions to sign up."
              )}
            </p>
          </div>
        </div>
        <div className="mb-4">
          <label
            className="form-label"
            htmlFor="resetPasswordSrEmail"
            tabIndex="0"
          >
            {t("Your email")}
          </label>
          <input
            type="email"
            className={`form-control form-control-lg ${
              submitted && errors.email
                ? "is-invalid"
                : submitted && username
                ? "is-valid"
                : ""
            }`}
            name="email"
            id="resetPasswordSrEmail"
            tabIndex="1"
            placeholder="Enter your email address"
            aria-label="Enter your email address"
            required=""
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          {submitted && errors.email && (
            <span className="invalid-feedback">
              {t(errors.email)}
            </span>
          )}
        </div>
        <div className="d-grid gap-2">
          <button type="submit" className="btn btn-primary btn-lg">
            {t("Submit")}
          </button>
          <div className="text-center">
            <button
              className="btn btn-link"
              onClick={() => navigate("/sign-in")}
            >
              <i className="bi-chevron-left"></i> {t("Back to Sign in")}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default ResendEmail;
